import { Cookies } from 'react-cookie';

export const ACCEPTED_COOKIES_KEY = 'DNET_ACCEPTED_COOKIES';

const cookies = new Cookies();
export const CookieDAO = cookies;
